import { createSlotRecipe } from './runtime';

const fileUploadConfig = {"name":"fileUpload","slots":["root","dropzone","item","itemDeleteTrigger","itemGroup","itemName","itemPreview","itemPreviewImage","itemSizeText","label","trigger"]}

export const fileUpload = /* @__PURE__ */ createSlotRecipe(fileUploadConfig)